// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";

import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";

Vue.config.productionTip = false;

Raven.config("https://12232078ac814f809f41385973045e52@sentry.io/1210484")
  .addPlugin(RavenVue, Vue)
  .install();

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js